/**
 * Javascript for handling the slideout menu when viewing the site on smaller screens
 */
var slideout = null;

/**
 * Indicate if the menu was in fact open before the `close` event was fired, and therefore if the menu icon needs to be updated.
 *
 * Explanation:
 *  The Slideout events `close` and `beforeclose` will fire even if the menu is slid out partially, but not all the way
 *  to trigger it to stay open. For example, someone has slid their finger on the screen with the intention of showing
 *  the menu, then realized they don't need it, so, without lifting their finger, slid it back to hide the menu again.
 *  At no point was the menu functionally open.
 *  So below, the Slideout.isOpen() function is used to determine if the menu was actually open directly before a `close`
 *  event was fired, or if it's a false positive, in which case the menu icon shouldn't be updated.
 *
 * @type {boolean}
 */
define([
    'jquery',
    'slideout',
    'debounce'
], function ($, Slideout, debounce) {
    'use strict';

    var boolToggleMenuIcon = false;
    var slideout = null;

    var $primaryNavigationMobile = $(".primary-navigation-mobile");
    var $lis = $primaryNavigationMobile.find("> li");

    var windowWidth = $(window).width();
    var lastWindowWidth = windowWidth;

    //Create the slideout menu object for small screens
    if (windowWidth < 960) {
        initializeSlideout($, Slideout);
    }

    //When the window resizes, destroy the current slideout instance, and determine if a new one is required
    $(window).on('resize', debounce(function() {
        windowWidth = $(window).width();

        // Don't do anything if the width of the window hasn't changed
        if(windowWidth === lastWindowWidth) {
            return;
        }

        destroySlideout($);
        if (windowWidth < 960) {
            initializeSlideout($, Slideout);
        }

        lastWindowWidth = windowWidth;
    }, 250));

    /**
     * Initialise the slideout menu for mobile navigation
     *
     * @param $
     * @param Slideout
     */
    function initializeSlideout($, Slideout) {
        //Only initialize if it hasn't been done already
        if (slideout !== null) {
            return
        }

        $lis.each(function() {
            var $li = $(this);
            var $subMenu = $li.find("ul");
            if ($subMenu.length !== 0) {
                $subMenu.addClass("u-hidden");
                $li.on('click', function(e) {
                    var $clickTarget = $(e.target);
                    var $parentLi = $clickTarget.closest("li");
                    if (!$parentLi.hasClass('level0')) {
                        return;
                    }
                    e.preventDefault();
                    $li.toggleClass('open').find("ul").toggleClass("u-hidden");
                });
            }
        });

        //Figure out the width of the slideout (to be set on the 'padding' option of slideout)
        var $slideout = $(".mobile-navigation-container");
        var slideoutWidthPercentage = (280 / 320) * 100; //Matches the percentage calculation in `_components.slideout.scss`

        var $parentContainer = $slideout.parent();
        var parentContainerWidth = $parentContainer.outerWidth();

        var pixelsPadding = parentContainerWidth * (slideoutWidthPercentage / 100);
        slideout = new Slideout({
            'panel': document.getElementById('page_wrapper'),
            'menu': $slideout[0],
            'padding': pixelsPadding,
            'tolerance': 70,
            'ignore': '.fotorama, .owl-carousel',
            'touch': false
        });

        //This .on() function doesn't seem to be able to handle multiple triggers at once
        slideout.on('beforeopen', function() {
            if (!slideout.isOpen()) {
                boolToggleMenuIcon = true;
            }
        });
        slideout.on('open', function() {
            if (boolToggleMenuIcon) {
                boolToggleMenuIcon = false;
                toggleMenuIcon($);
            }
        });
        slideout.on('beforeclose', function() {
            if (slideout.isOpen()) {
                boolToggleMenuIcon = true;
            }
        });
        slideout.on('close', function() {
            if (boolToggleMenuIcon) {
                boolToggleMenuIcon = false;
                toggleMenuIcon($);
            }
        });

        $('.navigation-bar-mobile__toggle').on('click', function() {
            slideout.toggle();
        });
    }

    /**
     * Toggle the 'open' class on the menu toggle button, which will switch between a hamburger menu icon, and a close icon
     *
     * @param jQuery $
     */
    function toggleMenuIcon($) {
        var $toggleButton = $(".navigation-bar-mobile__toggle");
        $toggleButton.toggleClass('open');
    }

    /**
     * Destroys the slideout instance
     */
    function destroySlideout($) {
        //Don't try to destroy it if it's already been done
        if (slideout === null) {
            return;
        }

        slideout.destroy();
        slideout = null;

        $('.navigation-bar-mobile__toggle').off('click');
        $lis.off('click');
    }

});
